import React from 'react';
import logo from "../assets/logo.jpg"
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from './ScrollToTop';
import { TbUsers, TbHeartHandshake, TbSchool, TbAward, TbRocket } from 'react-icons/tb';

const QuienesSomos = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <div className='bg-gray-50 min-h-screen'>
        {/* Banner de Título */}
        <div className='bg-slate-900 py-16 md:py-24 px-4 text-center'>
          <h1 className="text-4xl md:text-6xl font-black text-white tracking-tight uppercase">
            Quiénes Somos
          </h1>
          <div className='w-24 h-1.5 bg-blue-600 mx-auto mt-6 rounded-full'></div>
        </div>

        {/* Contenedor Principal */}
        <main className='max-w-6xl mx-auto px-4 -mt-12 md:-mt-16 pb-20'>
          <div className='bg-white shadow-2xl rounded-[2.5rem] md:rounded-[4rem] overflow-hidden border border-gray-100'>
            
            {/* Sección 1: Logo e Introducción */}
            <div className='grid md:grid-cols-2 gap-8 md:gap-16 p-8 md:p-16 items-center border-b border-gray-50'>
              <div className='relative group mx-auto'>
                <div className='absolute -inset-4 bg-blue-100 rounded-full blur-2xl opacity-40 group-hover:opacity-60 transition duration-1000'></div>
                <img 
                  className='relative w-[280px] md:w-[350px] mx-auto rounded-3xl shadow-2xl transition-transform duration-500 group-hover:scale-105' 
                  src={logo} 
                  alt='Logo Fundación' 
                />
              </div>

              <div className='flex flex-col justify-center space-y-6'>
                <div className='flex items-center gap-3 text-blue-600'>
                  <TbSchool size={28} />
                  <span className='font-bold tracking-widest uppercase text-sm'>Nuestra Raíz</span>
                </div>
                <p className='text-slate-700 text-lg md:text-xl leading-relaxed font-light italic border-l-4 border-blue-600 pl-6'>
                  Fundación Vida y Obra del Docente JDD nace en Barranquilla, Atlántico por iniciativa de la familia Duque Alzate, miembros de la Asociación de exalumnos del Colegio Biffi La Salle y de la comunidad de los Hermanos Cristianos de La Salle, con el fin de reconocer en el docente al líder que orienta la formación de personas, instituciones y comunidades en pro de un ser humano educado y formado que actúe en entornos que promuevan su bienestar, el de su familia y su comunidad.
                </p>
                <p className='text-slate-600 text-lg leading-relaxed font-light'>
                  ...con el fin de reconocer en el docente al líder que orienta la formación de personas, instituciones y comunidades en pro de un ser humano educado y formado que actúe en entornos que promuevan su bienestar, el de su familia y su comunidad.
                </p>
              </div>
            </div>

            {/* Sección 2: El Propósito y Legado (AHORA UNO DEBAJO DEL OTRO) */}
            <div className='bg-slate-50/50'>
              {/* Bloque: Nuestro Reconocimiento */}
              <div className='p-8 md:p-16 border-b border-gray-100'>
                <div className='flex items-center gap-4 mb-6'>
                  <TbAward size={32} className='text-blue-600' />
                  <h2 className='text-3xl font-black text-slate-900'>Nuestro Reconocimiento</h2>
                </div>
                <p className='text-slate-600 text-lg md:text-xl leading-relaxed font-light'>
                  La Fundación busca reconocer y estimular a los docentes que con su ejemplo de vida, vocación y conocimiento profesional, forman desde las aulas a seres humanos con metodologías construidas a partir de la realidad de su entorno y la necesidad de su transformación para la obtención de bienestar. Partimos del ejemplo de vida y obra del docente Javier Duque Duque, quien por más de 40 años como docente educó con vocación.
                </p>
              </div>
              
              {/* Bloque: Apoyo y Estructura (CON INFORMACIÓN COMPLETA) */}
              <div className='p-8 md:p-16'>
                <div className='flex items-center gap-4 mb-6'>
                  <TbRocket size={32} className='text-blue-600' />
                  <h2 className='text-3xl font-black text-slate-900'>Apoyo y Estructura</h2>
                </div>
                <p className='text-slate-600 text-lg md:text-xl leading-relaxed font-light'>
                  Dado que la educación es la base que da solidez, estructura y articula el progreso ordenado de la sociedad, la labor del docente se debe blindar, dándole el reconocimiento y apoyo que se merece. Para reconocer la vida y obra del docente se promueven espacios donde se resalta la labor del pedagogo y se divulgan sus aportes, además se otorgan reconocimientos e incentivos que permiten exaltar en vida las obras realizadas por los docentes. Así, se convierten en ejemplos para otros actores de la formación de los miembros de la comunidad tanto jóvenes como adultos.
                </p>
              </div>
            </div>

            {/* Sección 3: Cierre e Impacto */}
            <div className='p-8 md:p-16'>
              <div className='bg-blue-600 rounded-[2rem] md:rounded-[3rem] p-8 md:p-12 text-white relative overflow-hidden'>
                {/* Decoración sutil */}
                <TbHeartHandshake className='absolute -right-10 -bottom-10 text-blue-500 size-64 opacity-20 rotate-12' />
                
                <div className='relative z-10'>
                  <div className='flex items-center gap-4 mb-6'>
                    <TbUsers size={40} className='text-blue-200' />
                    <h3 className='text-2xl md:text-3xl font-bold italic'>Alianzas y Futuro</h3>
                  </div>
                  <p className='text-xl md:text-2xl font-light leading-relaxed opacity-95'>
                    Asimismo, se crean espacios de apoyo personal para el docente que le permitan acceder a opciones y oportunidades de carácter económico para financiar actividades de tipo académico, familiar, social o cultural. Para lograr estos objetivos, la Fundación Vida y Obra del docente JDD, crea alianzas y acuerdos, promueve iniciativas y actividades, e incentiva ideas que tengan el fin de apoyar desinteresadamente a los docentes que merecen ser exaltados por sus aportes y porque su cotidianidad no es un hecho aislado, debido a que sus acciones quedan impregnadas en la vida de sus educandos y de las instituciones testigos de su trabajo y vocación.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};



export default QuienesSomos;